import { PatientProviderRowWithProvider } from "#/api/patientProvider.type";
import MedicalRecordSummaryCard from "../medical-records/medical-record-summary-card";
import { formatTimeStampToHumanReadableDate } from "../utls/time";

interface ProviderSummaryCardProps {
  provider: PatientProviderRowWithProvider;
  onClick?: () => void;
}

const formatDate = (value?: string | null) => {
  if (!value) return undefined;
  try {
    return formatTimeStampToHumanReadableDate(value);
  } catch {
    return undefined;
  }
};

const getProviderName = (record: PatientProviderRowWithProvider) => {
  const provider = record.provider;
  if (provider?.firstName || provider?.lastName) {
    return `${provider?.firstName ?? ""} ${provider?.lastName ?? ""}`.trim();
  }
  const fallbackName = (provider as { name?: string | null } | undefined)?.name;
  return fallbackName ?? "Care provider";
};

export function ProviderSummaryCard({ provider, onClick }: ProviderSummaryCardProps) {
  const title = getProviderName(provider);
  const subtitle = provider.provider?.specialization ?? provider.institution?.name;
  const status = provider.is_primary ? "Primary" : provider.provider ? "Linked" : undefined;

  const meta = [
    {
      label: "Added",
      value: formatDate(provider.created_at),
    },
    {
      label: "Institution",
      value: provider.institution?.name,
    },
  ];

  return (
    <MedicalRecordSummaryCard
      title={title}
      subtitle={subtitle}
      status={status}
      statusTone={provider.is_primary ? "info" : "success"}
      meta={meta}
      onClick={onClick}
    />
  );
}

export default ProviderSummaryCard;
